import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output, OnDestroy, AfterViewInit } from '@angular/core';

import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
  selector: 'current-slip-component',
  templateUrl: '../sharedTemplates/current-slip.component.html',
})
export class CurrentSlipComponent {
  constructor(private _MatBottomSheet: MatBottomSheet, private bottomSheetRef: MatBottomSheetRef<CurrentSlipComponent>) {}

  closeBottomSheet(e): void {
    if (e) {
      this.bottomSheetRef.dismiss();
    }
  }
}
